module.exports = __webpack_public_path__ + "img/Bulgaria.352dae73.svg";